import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStoreService {
  private storage: Storage | null = null;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.storage = window.localStorage;
    }
  }

  public setItem(key: string, value: unknown) {
    if (!this.storage) {
      return;
    }

    const serializedValue = JSON.stringify(value);
    this.storage.setItem(key, serializedValue);
    return true;
  }

  public getItem<T = unknown>(key: string): T | null {
    if (!this.storage) {
      return null;
    }

    const value = this.storage.getItem(key);
    if (value === null) {
      return null;
    }

    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }

  public removeItem(key: string) {
    if (!this.storage) {
      return;
    }

    this.storage.removeItem(key);
  }

  public clear() {
    if (!this.storage) {
      return;
    }

    this.storage.clear();
  }
}
